<template>
  <div class="stats">
    <div class="stats-item">
      <span class="stats-item__label">Всего ТМЦ:</span>
      <span class="stats-item__value"> {{ filtered.total }}/{{ total.total }}</span>
    </div>
    <div class="stats-item">
      <span class="stats-item__label">Выдано:</span>
      <span class="stats-item__value"> {{ filtered.issued }}/{{ total.issued }}</span>
    </div>
    <div class="stats-item">
      <span class="stats-item__label">Свободно:</span>
      <span class="stats-item__value"> {{ filtered.free }}/{{ total.free }}</span>
    </div>
    <div class="stats-item">
      <span class="stats-item__label">Списано:</span>
      <span class="stats-item__value"> {{ filtered.writtenOff }}/{{ total.writtenOff }}</span>
    </div>
    <div class="stats-item">
      <span class="stats-item__label stats-item__label--warning">Из них просрочено:</span>
      <span class="stats-item__value"> {{ filtered.expired }}/{{ total.expired }}</span>
    </div>
    <div class="stats-item">
      <span class="stats-item__label">Общая стоимость, ฿:</span>
      <span class="stats-item__value"> {{ filtered.cost.toLocaleString() }}/{{ total.cost.toLocaleString() }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["total", "filtered", "loading"],
};
</script>

<style lang="scss">
@import "~@/assets/styles/vars";
.stats {
  background: #f5f7fa;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 4px 10px;
  min-height: 30px;
  line-height: 1;
  border-radius: 15px;

  &-item {
    display: flex;
    padding: 2px 10px;
    font-size: 13px;

    &__label {
      color: $color-label;
      margin-right: 5px;

      &--warning {
        color: $color-secondary;
      }
    }
    &__value {
      font-weight: 500;
    }
  }
}
</style>
